import React, { useEffect, useRef } from "react";
import Reveal from "./Reveal";
import { IMAGES } from "../../data/mock";
import { Award, BookOpen } from "lucide-react";

export default function CoachBio() {
  const imgWrap = useRef(null);
  useEffect(() => {
    const el = imgWrap.current;
    if (!el) return;
    const on = () => {
      const r = el.getBoundingClientRect();
      const inView = r.top < window.innerHeight && r.bottom > 0;
      if (!inView) return;
      const p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
      const y = (p - 0.5) * 80;
      const img = el.querySelector(".coach-img");
      if (img) img.style.transform = `translate3d(0, ${y}px, 0) scale(1.08)`;
    };
    window.addEventListener("scroll", on); on();
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <section id="coach" className="relative py-28 md:py-40 border-b hairline overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-[0.9fr_1.1fr] gap-14 md:gap-20 items-start">
        <div ref={imgWrap} className="relative aspect-[3/4] w-full overflow-hidden border hairline-2">
          <img src={IMAGES.coach} alt="Coach Colin" className="coach-img absolute inset-0 w-full h-full object-cover will-change-transform" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(10,9,8,0.85) 100%)" }}></div>
          <div className="absolute left-6 bottom-6 right-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--ember-3)]">The Coach</div>
            <div className="font-display text-[36px] leading-none mt-2">Colin</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text-muted)] mt-3">Founder · 27:17 Performance</div>
          </div>
        </div>

        <div className="md:pt-6">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] mb-6">The Coach</div>
          <Reveal>
            <h2 className="font-display text-[46px] md:text-[76px] leading-[0.98] tracking-[-0.03em]">
              Built by a brother.<br /> Not a <span className="italic-serif text-[var(--ember-3)]">brand</span>.
            </h2>
          </Reveal>

          <Reveal className="mt-10 space-y-6 text-[16.5px] leading-[1.8] text-[var(--text-muted)] max-w-[620px]">
            <p>I am a tax attorney by trade. I run a law firm. I have a wife, a goldendoodle, and more on my plate than any sane man should. I did not need another company.</p>
            <p>But I kept watching it. Christian men, in their 30s, 40s, 50s, <span className="italic-serif text-[var(--text)]">quietly falling apart</span>. Soft in the body. Distracted in the mind. Disconnected from the Word. Too tired at the end of the day to lead anyone, much less themselves. And nobody was saying anything.</p>
            <p>The world had no shortage of "alpha male" content. The church had no shortage of soft, sentimental content. But nobody was speaking to the Christian man who wanted to be <span className="text-[var(--text)]">strong</span>. So I built it.</p>
            <p className="text-[var(--text)]">2717 is not a fitness company. It is a forge. The forge I wished existed when I was the man who needed it most.</p>
            <p className="italic-serif text-[var(--ember-3)] text-[20px]">— Colin</p>
          </Reveal>

          <div className="mt-10 flex flex-wrap gap-6 border-t hairline pt-6">
            <div className="flex items-center gap-3"><Award size={16} className="text-[var(--ember-2)]"/><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)]">Certified Personal Trainer (CPT)</span></div>
            <div className="flex items-center gap-3"><BookOpen size={16} className="text-[var(--ember-2)]"/><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)]">Certified Nutritionist</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}
